import { doc, updateDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";

export const clearThumbnails = (res) =>
  res.map((item) => ({
    ...item,
    thumbnailUrl: "",
    thumbnailSize: null,
  }));

export const buildArchivedSelectsFieldKey = (timestamp) =>
  `selectedImages_${timestamp.replace(/[:.]/g, "_")}`;

export const confirmClientSelects = async ({
  db,
  functions,
  jobID,
  selectedImages,
  dropboxPath,
  jobDoc,
  jobName,
}) => {
  const selectsMadeTimestamp = new Date().toISOString();
  const clearedImages = clearThumbnails(selectedImages);

  const updateData = {
    selectedImages: clearedImages,
    selectsMade: true,
    selectsMadeTimestamp,
    imagesProcessed: false,
  };

  updateData[buildArchivedSelectsFieldKey(selectsMadeTimestamp)] =
    clearedImages;

  await updateDoc(doc(db, "ClientSelects", jobID), updateData);

  const batchCopyToClientSelects = httpsCallable(
    functions,
    "batchCopyToClientSelects"
  );

  const result = await batchCopyToClientSelects({
    files: selectedImages,
    basePath: dropboxPath,
    jobDoc,
    jobName,
    selectsMadeTimestamp,
  });

  return {
    selectsMadeTimestamp,
    result,
  };
};
